var map = {
	"./icon-banner-dex-cards-dark.svg": "9109",
	"./icon-banner-dex-cards.svg": "a849",
	"./icon-banner-dex-cloud-dark.svg": "512c",
	"./icon-banner-dex-cloud.svg": "2065",
	"./icon-banner-dex-mobile.svg": "59a0",
	"./icon-banner-dex-pn-dark.svg": "a27e",
	"./icon-banner-dex-pn.svg": "aa8c",
	"./icon-banner-dex-point-dark.svg": "f40a",
	"./icon-banner-dex-point.svg": "df54",
	"./icon-banner-dex-safe-dark.svg": "6be4",
	"./icon-banner-dex-safe.svg": "28d7",
	"./icon-banner-dexid.svg": "d798",
	"./icon-desktop.svg": "54ee",
	"./icon-dexcards.svg": "e887",
	"./icon-dexcloud.svg": "fbfd",
	"./icon-dexid.svg": "6f5c",
	"./icon-dexmobile.svg": "88cf",
	"./icon-dexpn.svg": "7c9e",
	"./icon-dexpoint.svg": "acb2",
	"./icon-dexsafe.svg": "7f8a",
	"./icon-mobile.svg": "dbcd",
	"./icon-save.svg": "dcdf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "366a";